import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
import jQuery from 'jquery'
import VueAnalytics from 'vue-analytics'
import FoundationCss from 'foundation-sites/dist/css/foundation.min.css'
import FoundationJs from 'foundation-sites'
Vue.use(FoundationCss)
Vue.use(FoundationJs)
Vue.config.productionTip = false
Vue.use(Vuex)
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
Vue.use(Autocomplete)
Vue.use(VueAnalytics, {
  id: 'UA-169373289-1',
  router
});

const store = new Vuex.Store({
  state: {
    map: false,
    markers: [],
    bounds: '',
    emplacements: [],
    commercants: [],
    commercant: {},
    emplacementsMap: {},
    loader: false,
    loaderMap: false,
    filters: '&',
    info: new window.google.maps.InfoWindow(),
    setCard: function(feature){
      let card = '';
      card += '<div class="info">';
      card += ' <div class="grid-x grid-padding-x">';
      card += '   <div class="cell show-for-medium medium-8 info-image" style="background-image:url(' + feature.properties.thumbnail + ')">';
      card += '    <a href="' + feature.properties.link + '">';
      card += '    </a>';
      card += '   </div>';
      card += '   <div class="cell small-12 medium-4 align-self-middle">';
      card += '     <div class="info-title">' + feature.properties.site_nom + '</div>';
      card += '     <div class="info-details"><i class="fas fa-map-marker-alt"></i><span class="info-lieu"> ' + feature.properties.ville + '</span> ' + feature.properties.emplacement_nom +  '<br><span class="info-service"><small><i class="far fa-clock"></i> ' + feature.properties.service + '</small></span></div>';
      card += '     <a href="' + feature.properties.link + '" class="button info-button"><i class="fas fa-shopping-bag"></i> Commander</a>';
      card += '   </div>';
      card += '  </div>';
      card += ' </div>';
      card += '</div>';
      return card;
    }
  },
  mutations: {
    SET_EMPLACEMENTS: function (state, data) {
      if (data) {
        if(data.features){
          state.emplacements = [...data.features];
        }else{
          state.emplacements = [...data];
        }
        state.emplacementsMap = { ...data };
      }
    },
    SET_COMMERCANTS: function (state, data) {
      if (data) {
        state.commercants = [...data.commercants];
      }
    },
    SET_COMMERCANT: function (state, data) {
      if (data) {
        state.commercant = {...data.commercant};
      }
    },
    SET_LOADER: function (state, stateLoader) {
      state.loader = stateLoader;
    },
    SET_FILTERS: function (state, data) {
      state.filters = data;
    },
  },
  actions: {
    fetchEmplacements: function (context) {
      context.commit('SET_LOADER', true);
      axios.get('https://fb-foodtruck.aemporter.fr/aemporter_api/emplacements/parametrable?filters=true' + this.state.filters)
          .then(response => {
            console.log(response.data);
            context.commit('SET_EMPLACEMENTS', response.data);
            context.commit('SET_LOADER', false);
          })
          .catch(e => {
            console.error(e);
          });
    },
    fetchCommercants: function (context) {
      context.commit('SET_LOADER', true);
      axios.get('https://fb-foodtruck.aemporter.fr/aemporter_api/commercants')
          .then(response => {
            context.commit('SET_COMMERCANTS', response.data);
            context.commit('SET_LOADER', false);
          })
          .catch(e => {
            console.error(e);
          });
    },
    fetchCommercant: function (context, data) {
      context.commit('SET_LOADER', true);
      axios.get('https://fb-foodtruck.aemporter.fr/aemporter_api/commercant/' + data)
          .then(response => {
            context.commit('SET_COMMERCANT', response.data);
            let emplacements = {};
            emplacements.features = [];
            response.data.commercant.emplacements.forEach(emplacement => {
              emplacements.features.push(emplacement);
            });
            context.commit('SET_EMPLACEMENTS', emplacements);
            context.commit('SET_LOADER', false);
          })
          .catch(e => {
            console.error(e);
          });
    },
    setFilters: function (context, data) {
      context.commit('SET_FILTERS', data);
    },
    initMap: function () {
      this.state.map = new window.google.maps.Map(document.getElementById("map"), {
        center: { lat: 0, lng: 0 },
        zoom: 8,
        maxZoom: 18,
        styles: [
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#6195a0"
              }
            ]
          },
          {
            "featureType": "administrative.province",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
              {
                "lightness": "0"
              },
              {
                "saturation": "0"
              },
              {
                "color": "#f5f5f2"
              },
              {
                "gamma": "1"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "all",
            "stylers": [
              {
                "lightness": "-3"
              },
              {
                "gamma": "1.00"
              }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#bae5ce"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#fac9a9"
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text",
            "stylers": [
              {
                "color": "#4e4e4e"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#787878"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "transit.station.airport",
            "elementType": "labels.icon",
            "stylers": [
              {
                "hue": "#0a00ff"
              },
              {
                "saturation": "-77"
              },
              {
                "gamma": "0.57"
              },
              {
                "lightness": "0"
              }
            ]
          },
          {
            "featureType": "transit.station.rail",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#43321e"
              }
            ]
          },
          {
            "featureType": "transit.station.rail",
            "elementType": "labels.icon",
            "stylers": [
              {
                "hue": "#ff6c00"
              },
              {
                "lightness": "4"
              },
              {
                "gamma": "0.75"
              },
              {
                "saturation": "-68"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#eaf6f8"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#c7eced"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "lightness": "-49"
              },
              {
                "saturation": "-53"
              },
              {
                "gamma": "0.79"
              }
            ]
          }
        ],
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false
      });
      window.google.maps.event.addListener(this.state.info, "domready", () => {
        document.querySelector('.gm-style-iw').style.padding = '0px';
        document.querySelector('.gm-style-iw-d').style.overflow = 'hidden';
        document.querySelector('.info').style.border = 'none';
        document.querySelector('button img').style.width = '20px';
        document.querySelector('button img').style.height = '20px';
        document.querySelector('button').style.top = '-4px';
        document.querySelector('button').style.right = '0';
        document.querySelector('button img').style.border = '2px solid #666666';
        document.querySelector('button img').style.borderRadius = '50%';
      });
    },
    loadDataOnMap: function () {
      this.state.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.state.markers = [];
      this.state.bounds = new window.google.maps.LatLngBounds();
      const icon = '/marker.png';
      this.state.emplacementsMap.features.forEach(feature => {
        this.state.markers[feature.properties.id] = new window.google.maps.Marker({
          id: feature.properties.id,
          position: {
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0]
          },
          icon: icon,
          map: this.state.map
        });

        this.state.markers[feature.properties.id].addListener('click', () => {
          let card = this.state.setCard(feature);
          this.state.info.setContent(card);
          this.state.info.open(this.state.map, this.state.markers[feature.properties.id]);
        });
        this.state.bounds.extend({
          lat: feature.geometry.coordinates[1],
          lng: feature.geometry.coordinates[0]
        });
      });
      this.state.map.fitBounds(this.state.bounds);
    },
  }
});

new Vue({
  FoundationCss,
  FoundationJs,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
jQuery(document).foundation();